import { CollectionType } from '@/enums/collection-type';
import { WebLocale } from '@/enums/web-locale';
import { RouteConfig } from 'vue-router/types/router';
import { PageType } from './config';

/**
 * Generate the app routes for Authors, List Articles, and
 * News Articles.
 *
 * @param currentLocale
 */
export function makeEditorialRoutes(currentLocale: WebLocale): RouteConfig[] {
	/*
        **IMPORTANT**
        The route order is important, they are evaluated in order so
        watchout for overlapping :dyanmic route segments!
    */

	const routes: RouteConfig[] = [];

	if (isEditorialLocale(currentLocale)) {
		routes.push(makeGuideRoute(currentLocale));
		routes.push(makeEditorialArticleRoute(currentLocale));
	}

	return routes;
}

////////////////////
/* GUIDE HOMEPAGE */
////////////////////
export const editorialSlugs = {
	[WebLocale.br]: 'guia',
	[WebLocale.bs]: 'guide',
	[WebLocale.de]: 'guide',
	[WebLocale.es]: 'guia',
	[WebLocale.fr]: 'guide',
	[WebLocale.in]: 'guide',
	[WebLocale.it]: 'guida',
	[WebLocale.mx]: 'guia',
	[WebLocale.tr]: 'haberler',
	[WebLocale.uk]: 'guide',
	[WebLocale.us]: 'guide',

	// [WebLocale.ar]: 'guia',
	// [WebLocale.au]: 'guide',
	// [WebLocale.ca]: 'guide',
} as const;
export type EditorialLocale = keyof typeof editorialSlugs;

export function isEditorialLocale(locale: WebLocale): locale is EditorialLocale {
	return locale in editorialSlugs;
}

export function makeGuideRoute(currentLocale: EditorialLocale): RouteConfig {
	return {
		path: `/${currentLocale}/${editorialSlugs[currentLocale]}`,
		name: 'app.editorial.list',
		component: () => import(/* webpackChunkName: "editorial" */ '@/pages/editorial/GuidePage.vue'),
		meta: { tab: 'editorial', pageType: PageType.EDITORIAL },
	};
}

////////////////////////
/* EDITORIAL ARTICLES */
////////////////////////
function makeEditorialArticleRoute(currentLocale: EditorialLocale): RouteConfig {
	// /{locale}/{guide} -> /de/news/:slug
	return {
		component: () => import(/* webpackChunkName: "editorial" */ '@/pages/editorial/EditorialArticle.vue'),
		name: 'app.editorial.article',
		path: `/${currentLocale}/${editorialSlugs[currentLocale]}/:slug`,
		meta: {
			tab: 'editorial',
			collectionType: CollectionType.EDITORIAL,
			context: ['filters'],
			pageType: PageType.EDITORIAL_ARTICLE,
		},
	};
}
